export default "__VITE_ASSET__BfnYFikK__"